import { render, staticRenderFns } from "./VsBox.vue?vue&type=template&id=6c5b21de&"
import script from "./VsBox.vue?vue&type=script&lang=js&"
export * from "./VsBox.vue?vue&type=script&lang=js&"
import style0 from "./VsBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports